/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Milestones_TitleInputs */

const en_us2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestones reached`)
};

const pt_br2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcos alcançados`)
};

const es_419_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitos alcanzados`)
};

const pt_pt2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcos alcançados`)
};

const fr_fr2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étapes franchies`)
};

const de_de2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreichte Meilensteine`)
};

const it_it2_workout_after_milestones_title = /** @type {(inputs: Workout_After_Milestones_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traguardi raggiunti`)
};

/**
* | output |
* | --- |
* | "Milestones reached" |
*
* @param {Workout_After_Milestones_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_milestones_title = /** @type {((inputs?: Workout_After_Milestones_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Milestones_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_milestones_title(inputs)
	if (locale === "es-419") return es_419_workout_after_milestones_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_milestones_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_milestones_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_milestones_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_milestones_title(inputs)
	return en_us2_workout_after_milestones_title(inputs)
});
export { workout_after_milestones_title as "workout-after.milestones_title" }